module.exports = __webpack_public_path__ + "media/images/devices/device-feature-performance-1c16fc7a7c9857ce5fcddd79ec61c300.png";